import React, { useEffect, Suspense } from "react";
import Layout from "./Components/Layout/Layout";
import { Route, Routes } from "react-router-dom";
import Spinner from "./Components/UI/Spinner/Spinner";

import { useDispatch } from "react-redux";
import { browserDataActions } from "./store/browserdata-slice";
import { fetchHardwareData } from "./store/hardwaredata-actions";
import { fetchProductData } from "./store/productdata-actions";
import ScrollToTop from "./Components/ScrollToTop";

const Error = React.lazy("./Components/Error/Error");
const SubProductsPage = React.lazy(() => import("./Pages/SubProductsPage"));
const Home = React.lazy(() => import("./Pages/Home"));
const Products = React.lazy(() => import("./Pages/Products"));
const ProductDetailsPage = React.lazy(() =>
  import("./Pages/ProductDetailsPage")
);

function App() {
  const dispatch = useDispatch();

  //passing browser height and width on redux
  useEffect(() => {
    const handleScroll = () => {
      dispatch(browserDataActions.getHeight(window.pageYOffset));
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", null);
  }, [dispatch]);

  useEffect(() => {
    function resizeHandler() {
      dispatch(browserDataActions.getWidth(window.innerWidth));
    }
    window.addEventListener("resize", resizeHandler);
    resizeHandler();
    return () => window.removeEventListener("resize", null);
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchProductData());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchHardwareData());
  });

  return (
    <Layout>
      <Suspense
        fallback={
          <div className="centered">
            <Spinner />
          </div>
        }
      >
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<SubProductsPage />} />
          <Route
            path="/products/:id/:productId"
            element={<ProductDetailsPage />}
          />
          <Route path="*" element={<Error />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}

export default App;
